import jwtDecode from "jwt-decode";

const CACHE_KEY = "accountree:db-sidebar:v1";
const CACHE_MAX_AGE_MS = 5 * 60 * 1000;

export async function getMenuCacheIdentity(authorization) {
  const token = typeof authorization === "string" ? authorization.replace(/^Bearer\s+/i, "") : "";
  if (!token || !window.crypto?.subtle || !window.TextEncoder) return null;

  try {
    const claims = jwtDecode(token);
    if (!Number.isFinite(claims.exp) || claims.exp * 1000 <= Date.now()) return null;
  } catch {
    return null;
  }

  const bytes = new window.TextEncoder().encode(token);
  const digest = await window.crypto.subtle.digest("SHA-256", bytes);
  return Array.from(new Uint8Array(digest), byte => byte.toString(16).padStart(2, "0")).join("");
}

export function readMenuCache(identity) {
  if (!identity) return null;
  try {
    const entry = JSON.parse(sessionStorage.getItem(CACHE_KEY) || "null");
    if (entry?.identity === identity &&
        Number.isFinite(entry.savedAt) &&
        Date.now() - entry.savedAt >= 0 &&
        Date.now() - entry.savedAt <= CACHE_MAX_AGE_MS &&
        Array.isArray(entry.items) && entry.items.length > 0) {
      return entry.items;
    }
    sessionStorage.removeItem(CACHE_KEY);
  } catch {
    // Storage may be unavailable; the API request remains authoritative.
  }
  return null;
}

export function writeMenuCache(identity, items) {
  if (!identity || !Array.isArray(items) || items.length === 0) return;
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ identity, savedAt: Date.now(), items }));
  } catch {
    // A full or disabled storage must not prevent the menu from loading.
  }
}
